import styled from "styled-components";

const HomeExtortionWrap = styled.div`
  background: linear-gradient(to top,#f4e1ff,#f4e1ff);
  padding: 72px 0;
`

export default HomeExtortionWrap